import { useSelector } from "react-redux";

import { UserRole } from "./enums";
import { selectUserData } from "./selectors";

export function useUserHasRole(role: UserRole): boolean {
  const { roles } = useSelector(selectUserData);

  return Boolean(roles[role]);
}

export function useAllowUserModifyProperty(property: string) {
  const properties = useSelector(selectUserData)?.customTask?.approvablePropertyUuids || [];
  return Boolean(properties.includes(property));
}
